import React from "react";
import GitHubCalendar from "react-github-calendar";
import ProjectCard from "./ProjectCard";
import "../Style/projects.css";
import html from "../Components/Images/Html.png";
import css from "../Components/Images/Css.png";
import react from "../Components/Images/react.png";
import js from "../Components/Images/js.png";
import chakra from "../Components/Images/chakra.png";
import redux from "../Components/Images/redux-seeklogo.com.svg";
import threejs from "../Components/Images/threejs.svg";
import node from "../Components/Images/nodejs.png";
import express from "../Components/Images/express.png";
import mongo from "../Components/Images/mongodb-seeklogo.com.svg";

const Projects = () => {
  let dataarr = [
    {
      imgarr: [
        {
          img: "https://user-images.githubusercontent.com/109611448/213923457-9a382633-b69c-4c7b-bb37-3212faacc999.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109611448/213923481-5667da3d-a857-43db-a507-4a7e2f306b8a.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109611448/213923495-e777a1e2-be9a-4263-b22b-41077b592c19.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109611448/213923515-93866847-14d3-4f78-b883-846706157ba6.png",
        },
      ],
      des: `1800-Flowers.com, Inc. is a floral and foods gift retailer and distribution company in the United States. This is a collaborative project build in 4 days.`,
      title: "1800flowers (Full Stack Application)",
      techstack: [
        { src: react, name: "React" },
        { src: redux, name: "Redux" },
        { src: node, name: "Node" },
        { src: express, name: "Express" },
        { src: mongo, name: "MongoDB" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://frontend-jyotiranjanghibila.vercel.app/`,
      github: `https://github.com/iamitpal/1800flowers-clone`,
    },
  ];
  let grow = [
    {
      imgarr: [
        {
          img: "https://i.postimg.cc/FHFzhDFd/radar1.png",
        },
        {
          img: "https://i.postimg.cc/sg8rbcMR/radar2.png",
        },
        {
          img: "https://i.postimg.cc/MHdk50CN/radar4.png",
        },
        {
          img: "https://i.postimg.cc/qRxWBXvq/radar3.png",
        },
      ],
      des: `Radar.com is a online CRM (Customer Relation Management) platform & provide various marketing services it is a solo project and done using React and chakra as css library`,
      title: "Radar.Com",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: react, name: "React" },
        { src: chakra, name: "Chakra" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://radar-olive.vercel.app/`,
      github: `https://github.com/iamitpal/gaping-nose-7154`,
    },
  ];
  let optimizely = [
    {
      imgarr: [
        {
          img: "https://i.postimg.cc/0NkJz98f/jfit1.png",
        },
        {
          img: "https://i.postimg.cc/26Jq9vnc/jfit2.png",
        },
        {
          img: "https://i.postimg.cc/kgmCCc9r/jfit4.png",
        },
        {
          img: "https://i.postimg.cc/596kRFhw/jfit3.png",
        },
        {
          img: "https://i.postimg.cc/J0XwVy24/jfit5.png",
        },
      ],
      des: `Jefit.com is a online platform that provides you customised workout and diet plan in just few clicks. Plan, track, and log your workouts in the #1 mobile fitness app. Choose from hundreds of professionally built workout plans and reach your goals quicker.`,
      title: "Jefit",
      techstack: [
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://magenta-malabi-2aad88.netlify.app/`,
      github: `https://github.com/iamitpal/social-reason-8`,
    },
  ];
  let movieholics = [
    {
      imgarr: [
        {
          img: "https://user-images.githubusercontent.com/109168129/234324086-bcb44247-c6f9-4083-a66c-e4eac93b9441.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234324536-9174d69a-f0ab-4a24-9859-15bca359466c.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234326527-d649aea7-d6b5-4057-b684-716c0f1eecb3.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234325251-17cda2b3-e107-48ed-977a-4ce34a4bc779.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234325331-888f2325-589a-472c-b31e-90c646e9a65a.png",
        },
      ],
      des: `A React-Redux Movie application where user can watch Movies and TV Shows, User can Filter and Sort based on rating and Genere, User can watch Trailer with In-built Player.`,
      title: "Movieholics",
      techstack: [
        { src: redux, name: "Redux" },
        { src: react, name: "React" },
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://movieholics.vercel.app/`,
      github: `https://github.com/iamitpal/Movieholics`,
    },
  ];
  let react3d = [
    {
      imgarr: [
        {
          img: "https://user-images.githubusercontent.com/109168129/229448971-37424275-d5b7-4cca-93dd-1e2fdaad0cff.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/229449983-1ee8a274-8bac-42f3-a819-05e5e3be59ef.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/229450173-8f0489d8-6582-4bf5-90d8-d19d721c2ab7.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/229450127-6d6c7db2-aa66-4289-b79b-89c5ce6fa6dc.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/229450156-1a73b9c6-d308-46b7-b779-8e083b6d6b74.png",
        },
      ],
      des: `React 3D Animation for better UI/UX using Three.js,Webgi,Gsap and React and 3D design of Apple 14 pro for better user experience with the product & Webgi SDK for 360 Degree View Of the product, Createing Better User Interface and User Experience.`,
      title: "React 3D Product (Three.Js)",
      techstack: [
        { src: threejs, name: "ThreeJS" },
        { src: react, name: "React" },
        { src: html, name: "HTML" },
        { src: css, name: "CSS" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://apple-3d-homepage.vercel.app/`,
      github: `https://github.com/iamitpal/react-3d-animation`,
    },
  ];
  let eShop = [
    {
      imgarr: [
        {
          img: "https://user-images.githubusercontent.com/109168129/234337476-06ca4039-d91a-45d6-b9e7-719696d7163e.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234339525-f7f6d30c-22c1-42a3-97cf-8bd7491b7105.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234339220-d1d15488-4050-49cf-af39-2f6b6ab45cd5.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234340536-9a9340ce-95af-4153-b574-ceba42d23fcc.png",
        },
        {
          img: "https://user-images.githubusercontent.com/109168129/234341343-ffde6a61-635f-43b7-8b04-bcce2a0e7a9c.png",
        },
      ],
      des: `A Complete Full Stack E-commerce website where user can purchase, Add to cart, Track Order & Pay Via PayPal Payment Integration for the product of their choice.`,
      title: "eShop (Full Stack Application)",
      techstack: [
        { src: react, name: "React" },
        { src: redux, name: "Redux" },
        { src: node, name: "Node" },
        { src: express, name: "Express" },
        { src: mongo, name: "MongoDB" },
        { src: js, name: "JavaScript" },
      ],
      live: `https://eshop-app-6gu5.onrender.com/`,
      github: `https://github.com/iamitpal/MERN-eShop`,
    },
  ];
  // console.log(dataarr);
  return (
    <section id="projects">
      <div
        id="tech"
        data-aos="fade-down-right"
        data-aos-duration="1500"
        data-aos-delay="70"
        margin={"auto"}
        justifyContent={"space-around"}
      >
        <h1 style={{ color: "var(--color-font)" }}>Projects</h1>
      </div>
      <div id="procard">
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={eShop} />
        </div>
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={react3d} />
        </div>
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={movieholics} />
        </div>
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={dataarr} />
        </div>
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={grow} />
        </div>
        <div
          data-aos="zoom-in-down"
          data-aos-duration="1500"
          data-aos-offset="70"
          data-aos-anchor-placement="top-center"
        >
          <ProjectCard arr={optimizely} />
        </div>
      </div>
      <div
        id="gitname"
        data-aos="fade-down-right"
        data-aos-duration="1500"
        data-aos-delay="100"
        margin={"auto"}
        justifyContent={"space-around"}
      >
        <h2 style={{ color: "var(--color-font)" }}>
          Github Contribution Calender{" "}
        </h2>
      </div>
      <div
        id="calendar"
        data-aos="flip-right"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="1500"
        data-aos-offset="100"
      >
        <GitHubCalendar
          fontSize={14}
          color="#4169e1"
          blockRadius={1}
          blockMargin={6}
          blockSize={16}
          showWeekdayLabels
          username="iamitpal"
        />
      </div>
      <div
        id="gitname"
        data-aos="fade-down-right"
        data-aos-duration="1500"
        data-aos-delay="100"
        margin={"auto"}
        justifyContent={"space-around"}
      >
        <h2 style={{ color: "var(--color-font)" }}>Github Stats</h2>
      </div>
      <div id="gitstats">
        <img
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="100"
          alt="most used languages"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=iamitpal&count_private=true&theme=algolia&bg_color=0,000000,130F40&layout=compact&border_radius=8&langs_count=20&hide=hack,swift,kotlin,objective-c"
        />

        <img
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="100"
          alt="status github, commits, etc..."
          src="https://github-readme-streak-stats.herokuapp.com/?user=iamitpal&count_private=true&show_icons=true&custom_title=Github&theme=algolia&bg_color=0,000000,130F40&layout=compact&border_radius=8"
        />

        <img
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="100"
          alt="7oSkaaa's Github Stats"
          src="https://github-readme-stats.vercel.app/api?username=iamitpal&show_icons=true&count_private=true&theme=algolia&bg_color=0,000000,130F40&layout=compact&border_radius=10"
        />
        <img
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="1500"
          data-aos-offset="100"
          alt="Hanumat Activity Graph"
          src="https://github-readme-activity-graph.cyclic.app/graph?username=iamitpal&theme=react-dark&hide_border=false"
        />
      </div>
    </section>
  );
};

export default Projects;
